import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getCmsService } from "redux/services/general_service";
import Header from "components/ui/Header2";
import Footer from "components/common/Footer";
import { useTranslation } from "react-i18next";

const CmsPage = () => {
  const {t} = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const { cms } = useSelector((state) => state.general);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log(location.pathname); // مثال: "/cms/privacy_policy"
    console.log(location.search);
console.log(cms)
    const fetchCms = async () => {
      setLoading(true);
      await dispatch(getCmsService(location.pathname));
      setLoading(false);
    };
    fetchCms();
  }, [location]);

  if (loading)
    return (
      <div className="min-h-screen flex justify-center items-center">
        جاري التحميل...
      </div>
    );

  const content = cms[location.pathname]?.content || "<p>لا يوجد محتوى.</p>";

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="w-full max-w-[1182px] mx-auto px-4 sm:px-6 lg:px-8 py-16">

           <h2 className="text-[20px] sm:text-[24px] lg:text-[32px] font-svn-gilroy font-bold leading-[28px] sm:leading-[32px] lg:leading-[40px] text-global-text8 mb-[20px] sm:mb-[30px]">
                {t(cms?.type)}
              </h2>
        <div dangerouslySetInnerHTML={{ __html: cms?.content }} />
      </div>
      <Footer />
    </div>
  );
};

export default CmsPage;
